export const aboutInfo = {
  brandName: '漫境',
  tagline: '为成年读者打造的精选漫画阅读空间',
  founded: '2024年',
  mission: '成年人的世界已经足够复杂，我们相信漫画应该成为一扇通向更深层思考与情感共鸣的窗口，而非逃避现实的工具。漫境致力于为成年读者甄选具有文学深度与艺术价值的漫画作品，让每一页翻动都成为一次有意义的阅读体验。',
  story: '漫境由一群热爱漫画的资深编辑和设计师于2024年创立。创始团队在出版和数字内容行业拥有超过十五年的经验，深知成年读者对于漫画内容有着不同于青少年的需求——更复杂的叙事、更成熟的主题、更精湛的画工。于是，漫境应运而生。\n\n我们与国内外顶尖漫画创作者和版权方合作，建立了一套严格的作品筛选机制。从叙事结构、画风质量到内容深度，每部入选作品都经过三审评估，确保为读者呈现真正值得花时间品读的佳作。\n\n两年间，漫境从一个小众阅读社区成长为一个拥有数十万忠实读者的平台。但我们始终保持着创立时的初心——做内容的守门人，而非流量的追逐者。',
  reputation: [
    { label: '注册读者', value: '38万+' },
    { label: '合作版权方', value: '120+' },
    { label: '收录作品', value: '2,500+' },
    { label: '读者好评率', value: '97.6%' },
  ],
  contact: {
    email: 'contact@manga-realm.readdy.ai',
    wechat: 'MangaRealm_Official',
    weibo: '@漫境官方',
    address: '上海市静安区南京西路1788号',
    hours: '周一至周五 9:00 - 18:00',
  },
};